import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {
    configurationElement, getCustomValueOption,
    getSubForm, getValidator, getValidatorFormField, isPointerConfigurationElement,
    typeFormValue
} from "../../../configurationProperty/configurationPropertyUtils";
import {combineLatest, EMPTY, Observable, of, Subscription} from "rxjs";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {ElementParse} from "../../../ParseClass/Element.Parse";
import {PossibleCommandsComponent} from "../possible-commands/possible-commands.component";
import {
    arrayIsSet, GlobalVariablesService,
    isNotNullOrUndefined,
    objectIsSet,
    stringIsSet
} from "../../../providers/service/global-variables.service";
import {dataForm} from "../../../widget/auto-complete-form/auto-complete-form.component";
import {catchError, finalize, map, startWith, switchMap, take} from "rxjs/operators";
import {htmlData, htmlFormElement} from "../../../pages/management-elements/elements-page/elements-page.component";
import {DeviceIotPageService} from "../../../providers/service/device-iot-page.service";
import {IotDevicesParse} from "../../../ParseClass/Iotdevices.Parse";
import {UpdateIotConfigurationComponent} from "../update-iot-configuration/update-iot-configuration.component";
import {AlertService} from "../../../providers/service/alert.service";
import {TranslateService} from "@ngx-translate/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {
    IoTDeviceConfigurationObject,
    IoTDeviceConfigurationParse2
} from "../../../ParseClass/IoTDeviceConfiguration.Parse";
import {AllDevicesService} from "../../../providers/service/all-devices.service";
import {
    UpdateIotPidConfigurationsComponent
} from "../update-iot-pid-configurations/update-iot-pid-configurations.component";
import {PidConfiguration} from "../../../ParseClass/pid_configurations";
import {SensorDataTypesParse} from "../../../ParseClass/sensor-data-types-parse";
import {PagePermission, PageType, PermissionType} from "../../../ParseClass/user-permissions-parse";
import {SensorModelCategoryType, SensorModelParse} from "../../../ParseClass/SensorModel.Parse";

@Component({
    selector: 'app-update-iot-device',
    templateUrl: './update-iot-device.component.html',
    styleUrls: ['./update-iot-device.component.scss'],
    standalone: false
})
export class UpdateIotDeviceComponent implements OnInit, OnDestroy {

    public htmlData: htmlData[] = [];
    public configElementSubForm: { element: configurationElement, htmlFormElement: htmlFormElement }[] = [];
    public subscriptionsKeyWithSubForm: Subscription[] = [];
    public form: UntypedFormGroup | undefined;
    public formSerial: UntypedFormGroup | undefined;
    sectionNumberName: { [k: string]: string } = {"0": 'features'}
    visualizedInTabGroup = true;
    public elements: ElementParse[] = [];
    public lastConfigPidConfigurationNotSaved: IoTDeviceConfigurationObject | undefined;
    private customFormSubscriptions: Subscription[] = [];
    public visualize = {iotConfiguration: true, iotPidConfigurations: true}

    private componentCustomValue: any = {possibleCommands: PossibleCommandsComponent}
    public serialValue$: Observable<string> = of('')
    userCanEditPage$: Observable<boolean>

    get device(): IotDevicesParse {
        return this.data.iotdevice
    }

    get disableFormFields() {
        return this.data.disableFormFields
    }

    get possibleValuesPointer() {
        return this.data.possibleValuesPointer
    }

    getPossibleValuesPointerByKey(keyName: string): any[] {
        return this.possibleValuesPointer && arrayIsSet(this.possibleValuesPointer[keyName]) ? this.possibleValuesPointer[keyName] : []
    }

    savingUpdateSerial = false

    constructor(public dialogRef: MatDialogRef<UpdateIotDeviceComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    iotdevice: IotDevicesParse,
                    disableFormFields: string[] | undefined,
                    possibleValuesPointer: { [k: string]: any [] },
                    sensorDataTypes: SensorDataTypesParse[],
                    sensorDataModel: SensorModelParse[],
                },
                private deviceIotPageService: DeviceIotPageService,
                private allElementService: AllDevicesService,
                private dialog: MatDialog,
                private fb: UntypedFormBuilder,
                private matDialog: MatDialog,
                private alertService: AlertService,
                private translateService: TranslateService,
                private globalVariablesService: GlobalVariablesService
    ) {

        this.userCanEditPage$ = this.globalVariablesService.getUserWrite$(PageType.DEVICES_SETTINGS)

        this.formSerial = this.fb.group({seriale: undefined})
    }

    ngOnInit(): void {
        this.composeForm(this.device, this.disableFormFields)
        if (this.device.objectId != null) {
            this.visualize.iotConfiguration = true
            this.visualize.iotPidConfigurations = true
        } else {
            this.visualize.iotConfiguration = false
            this.visualize.iotPidConfigurations = false
        }
    }

    ngOnDestroy(): void {
        this.customFormSubscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptionsKeyWithSubForm.forEach(sub => sub.unsubscribe())
    }

    private addHtmlElement(element: configurationElement, htmlFormElement: htmlFormElement, htmlData: htmlData[]): void {
        const key = element.section.toString()
        const tabGroupName = this.sectionNumberName.hasOwnProperty(key) ? this.sectionNumberName[key] : 'null';
        const index = htmlData.findIndex(htmlValue => htmlValue.tabGroupName === tabGroupName)
        if (index >= 0) {
            htmlData[index].forms.push(htmlFormElement)
        } else {
            htmlData.push({tabGroupName: tabGroupName, forms: [htmlFormElement]})
        }
    }


    private getPossibleValuesCurrentValue(possibleValues: string[], cValue: string, traductionKey: string): {
        possibleValues: dataForm[] | undefined,
        currentValue: string | undefined
    } {
        let currentValue;
        if (arrayIsSet(possibleValues)) {
            const pValues = possibleValues.map((possibleValue, index) => {
                const keyForm = possibleValue;
                if (possibleValue == cValue) {
                    currentValue = keyForm
                }
                const obj = {
                    valueForm: keyForm,
                    html: keyForm,
                    traduction: traductionKey + '.' + keyForm,
                }
                return obj
            })
            const index = pValues.findIndex((value) => value.valueForm == cValue)
            if (index < 0 && cValue != null) {
                pValues.push({valueForm: cValue, html: cValue, traduction: cValue})
                currentValue = cValue;
            }
            return {possibleValues: pValues, currentValue}
        } else {
            return {possibleValues: undefined, currentValue: cValue}
        }
    }

    private getPossibleValuePointer(keyname: string, currentValue: any): {
        possibleValues: dataForm[] | undefined,
        currentValue: string | undefined
    } {
        if (arrayIsSet(this.getPossibleValuesPointerByKey(keyname))) {
            let cValue

            const pValues = this.possibleValuesPointer[keyname].map(possibleValue => {
                if (currentValue != null && possibleValue.objectId == currentValue.objectId) {
                    cValue = possibleValue.objectId
                }
                const obj: dataForm = {
                    valueForm: possibleValue.objectId,
                    html: possibleValue.objectId,
                    traduction: this.deviceIotPageService.getTraduction(keyname, possibleValue)
                }
                return obj
            })
            return {possibleValues: pValues, currentValue: cValue}
        } else {
            return {possibleValues: undefined, currentValue: currentValue}
        }
    }


    private getFormGroupChild(element: configurationElement, detail: ElementParse | undefined, referenceKey: string): {
        formGroupChild: { formGroupName: string | undefined, fields: any[] | undefined } | undefined,
        subObjForm: { key: string, formGroup: UntypedFormGroup } | undefined
    } {
        const subForm = getSubForm(element, referenceKey)
        let formGroupChild: { formGroupName: string | undefined, fields: any[] | undefined };
        let formGroup;
        if (arrayIsSet(subForm)) {
            const subObjForm: { [k: string]: any } = {};
            const key = element.forms?.databaseKey! as keyof ElementParse
            const subDetail = detail != null && isNotNullOrUndefined(detail[key]) ? detail[key] : {};
            const subHtml: {
                type: typeFormValue,
                possibleValues: dataForm[] | undefined,
                formControlName: string,
                traduction: string
            }[] = [];
            subForm
                .sort((aValue, bValue) => aValue.sortingValue - bValue.sortingValue)
                .forEach(subElement => {
                    const pValueCurrent = this.getPossibleValuesCurrentValue(subElement.possibleValues!, subDetail[subElement.keyName], subElement.keyTraduction)
                    subObjForm[subElement.keyName] = [{
                        disabled: !element.editable,
                        value: pValueCurrent.currentValue,
                    }, getValidatorFormField(subElement)]
                    const subForm = {
                        type: subElement.typeForm,
                        possibleValues: pValueCurrent.possibleValues,
                        formControlName: subElement.keyName,
                        traduction: subElement.keyTraduction
                    }
                    subHtml.push(subForm);
                })
            formGroupChild = {formGroupName: undefined, fields: undefined};
            formGroupChild.formGroupName = element.forms?.databaseKey!;
            formGroupChild.fields = subHtml as any[];
            formGroup = this.fb.group(subObjForm)
            return {formGroupChild, subObjForm: {key: element.forms?.databaseKey!, formGroup: formGroup}};
        } else {
            return {formGroupChild: undefined, subObjForm: undefined}
        }
    }

    getFormHtmlData(configurationData: configurationElement[], detail: IotDevicesParse): {
        formGruop: UntypedFormGroup,
        htmlData: htmlData [],
        configElementSubForm: { element: configurationElement, htmlFormElement: htmlFormElement }[]
    } {
        const html: htmlData[] = [];
        const objForm: { [k: string]: any } = {};
        const configElementSubForm: any[] = [];
        configurationData.forEach(element => {
            if (element.showInForm) {

                let possibleValues;
                let valueForm;
                const keyName = element.keyName as keyof IotDevicesParse
                if (element.typeForm == typeFormValue.GEO_POINT) {
                    const lat = (detail[keyName] as any) ? (detail[keyName] as any).latitude : undefined;
                    const lng = (detail[keyName] as any) ? (detail[keyName] as any).longitude : undefined;
                    valueForm = {lat, lng};
                } else if (isPointerConfigurationElement(element)) {
                    const pValueCurrent = this.getPossibleValuePointer(keyName, detail[keyName])
                    possibleValues = pValueCurrent.possibleValues
                    valueForm = pValueCurrent.currentValue
                } else if (arrayIsSet(element.possibleValues)) {
                    const pValueCurrent = this.getPossibleValuesCurrentValue(element.possibleValues, (detail[keyName] as any), element.traductionKey + 'PossibleValues')
                    possibleValues = pValueCurrent.possibleValues
                    valueForm = pValueCurrent.currentValue
                } else {
                    valueForm = detail[keyName]
                }

                const htmlFormElement: htmlFormElement = {
                    type: element.typeForm,
                    possibleValues: possibleValues,
                    formControlName: element.keyName,
                    traduction: element.traductionKey,
                    formOptions: element.formOptions,
                    formGroupChild: undefined
                };
                objForm[element.keyName] = [{
                    value: valueForm,
                    disabled: !element.editable
                }, getValidator(element)]
                // const subFormValue = this.getFormGroupChild(element, detail, detail[keyName])
                // if (isNotNullOrUndefined(subFormValue.formGroupChild)) {
                //     htmlFormElement.formGroupChild = subFormValue.formGroupChild as any;
                //     objForm[subFormValue.subObjForm?.key!] = subFormValue.subObjForm?.formGroup;
                //     configElementSubForm.push({element: element, htmlFormElement: htmlFormElement})
                // }
                this.addHtmlElement(element, htmlFormElement, html);
            }

        })
        return {formGruop: this.fb.group(objForm), htmlData: html, configElementSubForm};
    }

    addControlFormGruopCustomValue(form: UntypedFormGroup, configurationData: configurationElement[]) {
        this.customFormSubscriptions.forEach(sub => sub.unsubscribe());
        getCustomValueOption(configurationData).forEach(element => {
            const validators = getValidator(element)
            form.addControl(element.keyName, this.fb.control(null));
            if (Array.isArray(validators) && arrayIsSet(validators)) {
                validators.forEach(validator => {
                    form.setValidators(validator)
                })
            }
            form.get(element.keyName)?.setValue({click: false, values: []});
            if (this.componentCustomValue[element.keyName] != null) {
                const sub = form.get(element.keyName)?.valueChanges
                    .pipe(
                        switchMap((val) => {
                            if (val && val.click) {
                                const value = this.form?.get(element.keyName)?.value
                                return this.matDialog.open(this.componentCustomValue[element.keyName], {
                                    data: {currentValue: value},
                                    minWidth: '300px',
                                    autoFocus: false,
                                    exitAnimationDuration: 0.1
                                }).afterClosed()
                            } else {
                                return EMPTY
                            }
                        })
                    )
                    .subscribe(val => {

                        if (arrayIsSet(val)) {
                            this.form?.get(element.keyName)?.setValue({click: false, values: val})
                        }
                    })
                if (sub instanceof Subscription) {
                    this.customFormSubscriptions.push(sub);
                }
            }

        })
    }

    disableAllKeyInForm(disableFormFields: string[]) {
        Object.keys(this.form?.value).forEach(key => {
            if (disableFormFields.includes(key)) {
                if (this.form?.get(key)) {
                    this.form?.get(key)?.disable({emitEvent: false})
                }
            }
        })
        this.form?.updateValueAndValidity()
    }

    public composeForm(detail: IotDevicesParse, disableFormFields: string[] | undefined) {
        this.htmlData = [];
        this.form = undefined;
        this.configElementSubForm = [];
        setTimeout(() => {
            const configurationData = this.deviceIotPageService.configuration.sort((aValue, bValue) => aValue.sortingValue - bValue.sortingValue);
            const valueFormHtml = this.getFormHtmlData(configurationData, detail)
            this.form = valueFormHtml.formGruop;
            if (this.form.get('seriale')) {
                this.serialValue$ = this.form.get('seriale')!.valueChanges.pipe(
                    startWith(undefined),
                    map(serial => {
                        return stringIsSet(serial) ? serial : this.translateService.instant('setSerial')
                    })
                )
                setTimeout(() => {
                    this.form!.get('seriale')?.setValue(this.form!.get('seriale')?.value)
                }, 0)
            }
            this.addControlFormGruopCustomValue(this.form, configurationData)
            this.htmlData = valueFormHtml.htmlData;
            if (this.htmlData.length > 1) {
                this.visualizedInTabGroup = true
            } else {
                this.visualizedInTabGroup = false
            }
            this.configElementSubForm = valueFormHtml.configElementSubForm;
            this.configElementSubForm.forEach(elementHtml => {
                const keyname = elementHtml.element.keyName
                const subScription = this.form?.get(keyname)?.valueChanges.subscribe(
                    changeValue => {
                        elementHtml.htmlFormElement.formGroupChild = this.getFormGroupChild(elementHtml.element, undefined, changeValue).formGroupChild as any
                    })
                if (subScription instanceof Subscription) {
                    this.subscriptionsKeyWithSubForm.push(subScription)
                }
            })
            if (arrayIsSet(disableFormFields)) {
                this.disableAllKeyInForm(disableFormFields);
            }


        })
    }

    clickSaveButton() {
        const values: { [k: string]: any } = {}
        Object.keys(this.form?.value).forEach(key => {
            if (!this.form?.get(key)?.pristine) {
                let valueSet = this.form?.get(key)?.value;
                if (arrayIsSet(this.getPossibleValuesPointerByKey(key))) {
                    const index = this.getPossibleValuesPointerByKey(key).findIndex(value => value.objectId == valueSet)
                    if (index >= 0) {
                        valueSet = this.getPossibleValuesPointerByKey(key)[index]
                    }
                }
                values[key] = valueSet;
            }
        })
        this.dialogRef.close(values)
    }

    loading = {iotConfiguration: false, iotPidConfigurations: false}

    elementsParse$() {
        if (arrayIsSet(this.deviceIotPageService.elementsParse)) {
            return of(this.deviceIotPageService.elementsParse)
        } else {
            return this.allElementService.getAllElements().pipe(
                map(elements => {
                    this.deviceIotPageService.elementsParse = elements;
                    return elements
                })
            )
        }
    }

    openIotConfiguration() {
        this.loading.iotConfiguration = true;
        this.elementsParse$().pipe(
            switchMap((elementParse) => {
                return this.deviceIotPageService.getIotConfiguration$(this.device)
                    .pipe(
                        map((iotConfiguration => {
                            return {iotConfiguration, elementParse}
                        })),
                        catchError(() => of({
                            iotConfiguration: new IoTDeviceConfigurationParse2(undefined),
                            elementParse
                        }))
                    )
            }),
            switchMap(({iotConfiguration, elementParse}) => {
                return this.userCanEditPage$.pipe(
                    take(1),
                    map((isEditor) => {
                        return {iotConfiguration, elementParse, isEditor}
                    })
                )
            }),
            switchMap(({elementParse, iotConfiguration, isEditor}) => {
                const machinePossibleModel = this.globalVariablesService.sensorModel?.filter(s => s.category == null || s.category == SensorModelCategoryType.machine || s.category == SensorModelCategoryType.machineMeter)
                const metersPossibleModel = this.globalVariablesService.sensorModel?.filter(s => s.category == null || s.category == SensorModelCategoryType.meter || s.category == SensorModelCategoryType.machineMeter)
                const sensorDataType = this.globalVariablesService.sensorDataType
                const seriale = stringIsSet(this.data.iotdevice.seriale) ? this.data.iotdevice.seriale : this.form?.get('seriale')?.value;
                return this.dialog.open(UpdateIotConfigurationComponent, {
                    data: {
                        iotDevice: this.device,
                        currentValue: iotConfiguration,
                        save: (configuration: IoTDeviceConfigurationObject) =>
                            iotConfiguration?.setConfiguration$(this.deviceIotPageService.progetto?.objectId!, configuration, seriale).pipe(
                                finalize(() => this.deviceIotPageService.removeIotConfigurationStored(this.data.iotdevice))
                            ),
                        possibleValuesPointer: {element: elementParse},
                        possibleValuesSpecial: {
                            machines: {model: machinePossibleModel},
                            meters: {model: metersPossibleModel},
                        },
                        sensorDataType,
                        isEditor
                    },
                    width: '100vw',
                    maxWidth: '100vw',
                    height: 'calc(100vh - 30px)',
                    maxHeight: 'calc(100vh - 30px)',
                    autoFocus: false,
                    exitAnimationDuration: 0.1

                }).afterClosed()
            })
        ).subscribe((result: { configuration?: IoTDeviceConfigurationObject } | undefined) => {
            if (result?.configuration != null) {
                this.alertService.success(this.translateService.instant('IotDevices.configuratioUpdate'));
            }
            this.loading.iotConfiguration = false;
        }, error => {
            console.error(error)
            this.loading.iotConfiguration = false;
            this.alertService.error(error);
        }, () => {
            this.loading.iotConfiguration = false;
        })
    }

    openIotPidConfiguration() {
        const allRoles$ = this.globalVariablesService.allRoles$.pipe(
            take(1)
        )

        this.loading.iotPidConfigurations = true;
        this.elementsParse$().pipe(
            switchMap((elementParse) => {
                return this.deviceIotPageService.getIotPidConfigurations$(this.data.iotdevice)
                    .pipe(
                        map((oldPidConfigurations => {
                            return {oldPidConfigurations, elementParse}
                        })),
                        catchError(() => of({
                            oldPidConfigurations: undefined,
                            elementParse
                        }))
                    )
            }),
            switchMap(({oldPidConfigurations, elementParse}) => {
                return this.userCanEditPage$.pipe(
                    take(1),
                    map(isEditor => {
                        return {oldPidConfigurations, elementParse, isEditor}
                    })
                )
            }),
            switchMap(({elementParse, oldPidConfigurations, isEditor}) => {
                const configNotSaved = this.lastConfigPidConfigurationNotSaved;
                return this.dialog.open(UpdateIotPidConfigurationsComponent, {
                    data: {
                        currentPidConfigurations: oldPidConfigurations,
                        configNotSaved,
                        elements: elementParse,
                        sensorDataTypes: this.data.sensorDataTypes,
                        isEditor
                    },
                    width: '100vw',
                    maxWidth: '100vw',
                    autoFocus: false,
                    exitAnimationDuration: 0.1

                }).afterClosed().pipe(
                    map(((newConfigurations: {
                        pidConfigurations: PidConfiguration[],
                    }) => {
                        return {oldPidConfigurations, newConfigurations}
                    }))
                )
            }),
            switchMap(({oldPidConfigurations, newConfigurations}) => {
                if (objectIsSet(newConfigurations)) {
                    const newPidConfigurations = newConfigurations.pidConfigurations
                    const seriale = stringIsSet(this.data.iotdevice.seriale) ? this.data.iotdevice.seriale : this.form?.get('seriale')?.value;
                    const projectId = this.deviceIotPageService.progetto?.objectId;
                    return this.deviceIotPageService.setPidConfigurations$(projectId, seriale, newPidConfigurations).pipe(
                        catchError(error => {
                            return of({error, configuration: newPidConfigurations})
                        })
                    )

                } else {
                    this.loading.iotConfiguration = false;
                    return EMPTY;
                }
            })
        ).subscribe((value: any) => {
            if (value != null && typeof value == "object" && 'error' in value) {
                this.loading.iotPidConfigurations = false;
                this.alertService.error(value.error);
                this.lastConfigPidConfigurationNotSaved = value.configuration;
            } else {
                this.deviceIotPageService.removeIotPidConfigurationStored(this.data.iotdevice)
                const salvato: string = this.translateService.instant('IotDevices.configuratioUpdate');
                this.alertService.success(salvato);
                this.lastConfigPidConfigurationNotSaved = undefined;
            }
            this.loading.iotPidConfigurations = false;

        }, error => {
            console.error(error)
            this.loading.iotPidConfigurations = false;
            this.alertService.error(error);
        }, () => {
            this.loading.iotPidConfigurations = false;
        })
    }

    private dialogSerial: any;

    openSerialDialog(template: any) {
        if (this.dialogSerial) {
            this.dialogSerial.close(undefined)
        }
        this.dialogSerial = this.matDialog.open(template,
            {
                minWidth: '330px',
                autoFocus: false,
            }
        )
        this.dialogSerial.afterClosed().pipe(
            switchMap((seriale: string) => {
                if (stringIsSet(seriale)) {
                    if (this.data.iotdevice && stringIsSet(this.data.iotdevice.seriale)) {
                        const current = this.form?.get('seriale')!.value
                        return this.deviceIotPageService.changeEdgeDeviceSerial$(current, seriale).pipe(
                            map(device => seriale)
                        )
                    } else {
                        this.form?.get('seriale')!.setValue(seriale)
                        return EMPTY
                    }
                } else {
                    return EMPTY;
                }
            })
        )
            .subscribe((seriale: any) => {
                this.form?.get('seriale')!.setValue(seriale)
                this.alertService.success('Device ' + this.translateService.instant('alert.success'))
                this.data.iotdevice.seriale = seriale
            }, (error: any) => {
                this.alertService.error(error)
                this.savingUpdateSerial = false
            }, () => this.savingUpdateSerial = false)
    }

    closeSerial() {
        this.savingUpdateSerial = true
        this.dialogSerial.close(undefined)
    }

    saveSerial() {
        this.dialogSerial.close(this.formSerial!.get('seriale')!.value)
    }


}
